import { render, staticRenderFns } from "./StageModal.vue?vue&type=template&id=4a1209f9"
import script from "./StageModal.vue?vue&type=script&lang=js"
export * from "./StageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports